import { render, staticRenderFns } from "./Form813_v2.vue?vue&type=template&id=2e83af87&scoped=true&"
import script from "./Form813_v2.vue?vue&type=script&lang=js&"
export * from "./Form813_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form813_v2.vue?vue&type=style&index=0&id=2e83af87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e83af87",
  null
  
)

export default component.exports